import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uniqueId from 'react-html-id';
import { TRACKING_PLATFORM_IS_REQUIRED } from '../../../utils/messages';
import { TEXT_FIELD_STATUS } from '../../../utils/constants';
import './RadioButtonGroup.scss';


class RadioButtonGroup extends Component {
  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.node.isRequired).isRequired,
    values: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    value: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    changeHandler: PropTypes.func.isRequired,
    isRequired: PropTypes.bool,
    registerField: PropTypes.func.isRequired,
    status: PropTypes.string.isRequired,
    errorText: PropTypes.string.isRequired,
    header: PropTypes.string,
    viewSelected: PropTypes.bool,
  }

  static defaultProps = {
    isRequired: false,
    header: '',
    viewSelected: false,
  }

  constructor() {
    super();
    uniqueId.enableUniqueIds(this);
  }

  componentDidMount() {
    const { name, registerField } = this.props;
    registerField({ name, validator: this.standardValidator });
  }

  changeHandler = (e) => {
    e.preventDefault();
    const {
      target: {
        value,
      },
    } = e;
    const { name, changeHandler } = this.props;
    changeHandler({ value, name });
  }

  standardValidator = (value) => {
    const { isRequired } = this.props;

    let valid = true;
    let errorText = '';

    if (isRequired && !(value && value.length)) {
      valid = false;
      errorText = TRACKING_PLATFORM_IS_REQUIRED;
    }
    const status = valid
      ? TEXT_FIELD_STATUS.VALID
      : TEXT_FIELD_STATUS.INVALID;

    return { status, errorText };
  };

  renderOption = (child, optionValue, value) => {
    const currentId = this.nextUniqueId();
    const { viewSelected } = this.props;
    const radioClasses = classNames({
      'radio-label': true,
      'checked-radio-label': optionValue === value,
    });
    if (viewSelected && optionValue === value) {
      return (
        <div className={radioClasses} key={currentId}>

          <div className="radio-content">{child}</div>

        </div>
      );
    }
    if (!viewSelected) {
      return (

        <label className={radioClasses} key={currentId} htmlFor={currentId}>
          <div className="custom-radio-wrapper">
            <div className="custom-radio-pulse" />
            <div className="radio-border"><div className="radio-inner" /></div>
          </div>
          <input id={currentId} onClick={this.changeHandler} name={optionValue} checked={value === optionValue} type="radio" value={optionValue} />
          <div className="radio-content">{child}</div>
        </label>
      );
    }
    return null;
  }

  render() {
    const {
      children, values, value, header, errorText, status,
    } = this.props;
    const radioButtonClasses = classNames({
      'radio-button-group-wrapper': true,
      'radio-group-failed': status === TEXT_FIELD_STATUS.INVALID,
    });
    return (
      <div className={radioButtonClasses}>
        {header && <div className="radio-group-header"><span>{header}</span></div> }
        <div className="radio-button-group">
          {React.Children.map(children, (child, i) => this.renderOption(child, values[i], value))}
        </div>
        <div className="radio-group-error-text"><span>{errorText}</span></div>
      </div>
    );
  }
}


export default RadioButtonGroup;



// WEBPACK FOOTER //
// ./src/components/_molecules/RadioButtonGroup/RadioButtonGroup.js